import React from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import QRCode from 'qrcode.react'
import { CheckinReceiptSheet } from '@/utils/checkin-receipt-sheets'

type Props = {
  room: NonNullable<CheckinReceiptSheet['room']>
}

export const RoomSection: React.FC<Props> = ({ room }) => {
  const { t } = useTranslation()
  return (
    <div className="room-block">
      <div className="room-row">
        <span className="label">{t('SelfCheckIn.Room')}</span>
        <span className="value">{room.number}</span>
      </div>
      {room.key && (
        <div className="room-row">
          <span className="label">{t('SelfCheckIn.Key')}</span>
          <span className="value">{room.key}</span>
        </div>
      )}
      {room.qrCode && (
        <>
          <hr className="-normal" />
          <div className="qr-code-block">
            {/* Figma の部屋の QR コードは、255px の中に白い余白を含む（黒い部分は約 208px） */}
            <QRCode value={room.qrCode} size={255} includeMargin />
          </div>
          <div className="qrcode-description">
            {t('SelfCheckIn.QRCodeDoorInstruction')}
            <br /> {t('SelfCheckIn.QRCodeReceiptAdvice')}
          </div>
        </>
      )}
      {room.cardReplacementDate && (
        <div className="card-replacement-notice">
          {t('SelfCheckIn.cardReplacementNotice', {
            date: dayjs(room.cardReplacementDate).format('MM/DD'),
            interpolation: { escapeValue: false },
          })}
        </div>
      )}
      <hr className="-normal" />
    </div>
  )
}
